<div class="col full-height layout-column">

  <div class="flex layout-column overflow-auto"
       cdkDropList
       [cdkDropListData]="editableTasks"
       [cdkDropListDisabled]="!!isLoading"
       [cdkDropListSortPredicate]="sortPredicate"
       (cdkDropListEntered)="enter($event)"
       (cdkDropListDropped)="drop($event)">


    <app-agent-itinerary-edit-list-item *ngFor="let task of editableTasks; let index = index"
                                        cdkDrag
                                        [cdkDragDisabled]="task.taskType === 'Internal'"
                                        [cdkDragData]="task"
                                        (cdkDragStarted)="onDragStart.emit($event)"
                                        [task]="task">
      <div cdkDragHandle></div>
    </app-agent-itinerary-edit-list-item>

<!--    [cdkDragDisabled]="task.taskType === 'Internal' || task.status === 'CourierHeading' || task.status === 'CourierArrived'"-->

    <ng-template *cdkDragPlaceholder>
      <div class="placeholder">Drop here</div>
    </ng-template>

  </div>


</div>
